import React from 'react';
import AcceptBar from 'components/leads/acceptBar';
import Messages from 'views/leads/messages';
import EventDetails from 'components/events/eventDetails';

export default function (props) {
    const lead = props.lead;

    return (
        <div className="event-details">
            {!lead.accepted && !lead.rejected && !lead.options.expired && <AcceptBar lead={lead} />}
            {lead.options.expired && <div className="event-notice">
                <div className="container">
                    <span className="notice-message">
                        Sorry, this lead has expired. Leads expire after 24 hours or when five other venues have already responded, whichever comes first.
                    </span>
                </div>
            </div>}

            <div className="container">
                <EventDetails event={lead.event} />

                <div className="event-lead">
                    {lead.rejected && <div className="alert alert-danger">
                        You've declined this lead.
                    </div>}

                    {lead.accepted && <Messages lead={lead} />}
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/leads/details.jsx